{
  "status": {
    "trialing": "Trial",
    "active": "Paying",
    "on_hold": "On hold",
    "past_due": "Past due",
    "cancelled": "Cancelled",
    "expired": "Expired",
    "none": "No plan"
  },
  "copy": {
    "link": {
      "done": "Link copied",
      "failed": "Couldn't copy. Select the link and copy it by hand."
    },
    "signupLink": {
      "done": "Sign-up link copied",
      "failed": "Couldn't copy. Select the sign-up link and copy it by hand."
    }
  },
  "share": {
    "subject": "Deburr for first article inspections",
    "body": "We use Deburr to balloon drawings and turn out AS9102 FAI reports fast. Sign up with this link and we both get a free month:"
  },
  "prompt": {
    "label": "Refer a shop",
    "title": "Know a shop that still balloons by hand?",
    "body": "Send them your link. When they start paying, you both get a free month.",
    "copy": "Copy link",
    "email": "Email it",
    "dismiss": "Dismiss"
  },
  "dashboard": {
    "title": "Partner dashboard",
    "notPartner": {
      "title": "This account isn't a partner yet",
      "body": "Quality consultants and inspection labs who run FAIs for several shops can join the partner program. Email us and we'll set you up."
    },
    "col": {
      "shop": "Shop",
      "plan": "Plan",
      "openFais": "Open FAIs",
      "lastActivity": "Last activity",
      "estMonthly": "Est. monthly"
    },
    "unnamed": "Unnamed shop",
    "youRole": "You: {{role}}",
    "notMember": "You are not a member",
    "noneYet": "None yet",
    "open": "Open",
    "noAccess": "No access",
    "noAccessHint": "Ask the shop owner to invite you",
    "sub": "{{name}} · {{pct}}% revenue share",
    "copyLink": "Copy sign-up link",
    "newClient": "New client shop",
    "kpi": {
      "clients": "Client shops",
      "paying": "Paying",
      "openFais": "Open FAIs",
      "commission": "Est. commission / month"
    },
    "search": "Search client shops",
    "empty": {
      "noMatch": "No client shop matches",
      "none": "No client shops yet",
      "tryAnother": "Try another name.",
      "body": "Create a shop for a client, or send them your sign-up link. Shops that sign up through it show up here."
    },
    "linkLabel": "Your sign-up link:",
    "commission": "Commission is {{pct}}% of what paying client shops pay, estimated from list price. Trials earn nothing until they pay.",
    "payouts": {
      "title": "Payout statements",
      "month": "Month",
      "amount": "Amount",
      "status": "Status",
      "paid": "Paid {{date}}",
      "due": "Due"
    }
  },
  "newClient": {
    "nameRequired": "Give the shop a name.",
    "createdInvited": "{{name}} created. Invite sent to {{email}}.",
    "created": "{{name}} created.",
    "title": "New client shop",
    "sub": "Starts a 14-day trial. You join as admin, and the shop is linked to your partner account.",
    "create": "Create shop",
    "name": "Shop name",
    "namePlaceholder": "Acme Precision Machining",
    "email": "Owner's email (optional)",
    "emailHint": "We'll invite them as owner so they can pick a plan. You can invite them later from Team settings."
  }
}
